// Dev-only mock config — defines the target shape for the lead dev to hook up via componentStore
export default {
    psp: 'vol',
    headerCId: null, // set to a component cId string to override the default header
    header: {
        headline: { field: 'VOL_FULL_NAME' },
        monogram: [
            { field: 'VOL_FIRST_NAME' },
            { field: 'VOL_LAST_NAME' },
        ],
        meta: [
            { field: 'VOLUNTEER_ID', icon: 'fa-solid fa-id-card' },
            { field: 'ORG_NAME', icon: 'fa-solid fa-building' },
            { field: 'VOL_FULL_CITY_ADDRESS', icon: 'fa-solid fa-location-dot' },
        ],
        badges: [
            { field: 'VOL_ACTIVITY_STATUS', label: 'Active', type: 'active' },
            { field: 'CUSTOM_ATTRIBUTE#1505400', label: 'Application', type: 'cleared' },
        ],
    },
    tabs: [
        {
            id: 'tab_overview',
            label: 'Overview',
            icon: 'overview',
            cards: [
                {
                    id: 'card_personal_info',
                    title: 'Personal Info',
                    type: 'fields',
                    fields: ['VOL_FIRST_NAME', 'VOL_LAST_NAME', 'VOL_BIRTH_DATE', 'VOL_GENDER'],
                    position: {
                        row: 0, col: 0, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_contact',
                    title: 'Contact Info',
                    type: 'fields',
                    fields: ['VOL_EMAIL', 'VOL_MOBILE', 'VOL_HOME', 'VOL_ADDRESS', 'VOL_CITY', 'VOL_STATE', 'VOL_ZIPCODE'],
                    position: {
                        row: 0, col: 3, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_emergency_contact',
                    title: 'Emergency Contact',
                    type: 'fields',
                    fields: ['EMERG_NAME', 'EMERG_RELATIONSHIP', 'EMERG_PHONE'],
                    position: {
                        row: 2, col: 0, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_availability',
                    title: 'Availability',
                    type: 'fields',
                    fields: ['VOL_AVAILABILITY_DAYS', 'VOL_AVAILABILITY_TIMES'],
                    position: {
                        row: 2, col: 3, sizeX: 3, sizeY: 2
                    }
                }
            ]
        },
        {
            id: 'tab_volunteer_info',
            label: 'Volunteer Info',
            icon: 'user',
            cards: [
                {
                    id: 'card_skills',
                    title: 'Skills & Experience',
                    type: 'tags',
                    fields: ['VOL_SKILLS_LIST', 'VOL_PROFESSIONS', 'VOL_LANGUAGES'],
                    position: {
                        row: 0, col: 0, sizeX: 4, sizeY: 2
                    }
                },
                {
                    id: 'card_interests',
                    title: 'Interests',
                    type: 'tags',
                    fields: ['VOL_INTERESTS_LIST'],
                    position: {
                        row: 0, col: 4, sizeX: 2, sizeY: 2
                    }
                },
                {
                    id: 'card_preferences',
                    title: 'Role Preferences',
                    type: 'fields',
                    fields: ['PREF_VIRTUAL_ONLY', 'PREF_MAX_DRIVE_DISTANCE', 'PREF_ACCESSIBILITY_NEEDS'],
                    position: {
                        row: 2, col: 0, sizeX: 6, sizeY: 2
                    }
                }
            ]
        },
        {
            id: 'tab_custom_fields',
            label: 'Custom Fields',
            icon: 'fa-regular fa-sharp fa-cabinet-filing',
            isFullPage: true,
            cards: [
                {
                    id: 'card_custom_fields',
                    title: 'Custom Fields',
                    type: 'component',
                    component: 'customFields',
                    position: {
                        row: 0, col: 0, sizeX: 5, sizeY: 4
                    }
                }
            ]
        },
        {
            id: 'tab_workflow',
            label: 'Workflow',
            icon: 'clipboard',
            cards: [
                {
                    id: 'card_onboarding_status',
                    title: 'Onboarding Progress',
                    type: 'progress',
                    fields: ['WF_ONBOARDING_PERCENT', 'WF_CURRENT_STAGE'],
                    position: {
                        row: 0, col: 0, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_assignments',
                    title: 'Current Assignments',
                    type: 'list',
                    fields: ['WF_ACTIVE_ROLES', 'WF_UPCOMING_SHIFTS'],
                    position: {
                        row: 0, col: 3, sizeX: 3, sizeY: 3
                    }
                },
                {
                    id: 'card_application_details',
                    title: 'Application Details',
                    type: 'fields',
                    fields: ['WF_APPLIED_DATE', 'WF_INTERVIEW_DATE', 'WF_APPROVED_BY'],
                    position: {
                        row: 2, col: 0, sizeX: 3, sizeY: 2
                    }
                }
            ]
        },
        {
            id: 'tab_compliance',
            label: 'Compliance',
            icon: 'shield',
            cards: [
                {
                    id: 'card_background_check',
                    title: 'Background Check',
                    type: 'status',
                    fields: ['COMP_BG_STATUS', 'COMP_BG_SUBMIT_DATE', 'COMP_BG_CLEAR_DATE', 'COMP_BG_EXPIRY_DATE'],
                    position: {
                        row: 0, col: 0, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_trainings',
                    title: 'Required Trainings',
                    type: 'list',
                    fields: ['COMP_TRAINING_ORIENTATION', 'COMP_TRAINING_SAFETY', 'COMP_TRAINING_DATA_PRIVACY'],
                    position: {
                        row: 0, col: 3, sizeX: 3, sizeY: 3
                    }
                },
                {
                    id: 'card_waivers',
                    title: 'Signed Waivers',
                    type: 'fields',
                    fields: ['COMP_LIABILITY_WAIVER', 'COMP_PHOTO_RELEASE'],
                    position: {
                        row: 2, col: 0, sizeX: 3, sizeY: 2
                    }
                }
            ]
        },
        {
            id: 'tab_logbook',
            label: 'Logbook',
            icon: 'book',
            cards: [
                {
                    id: 'card_hours_summary',
                    title: 'Hours Summary',
                    type: 'metrics',
                    fields: ['LOG_LIFETIME_HOURS', 'LOG_YTD_HOURS', 'LOG_THIS_MONTH_HOURS'],
                    position: {
                        row: 0, col: 0, sizeX: 6, sizeY: 1
                    }
                },
                {
                    id: 'card_recent_shifts',
                    title: 'Recent Shifts',
                    type: 'table',
                    fields: ['LOG_SHIFT_DATE', 'LOG_SHIFT_ROLE', 'LOG_SHIFT_HOURS', 'LOG_SHIFT_SUPERVISOR'],
                    position: {
                        row: 1, col: 0, sizeX: 6, sizeY: 4
                    }
                }
            ]
        },
        {
            id: 'tab_attachments',
            label: 'Attachments',
            icon: 'paperclip',
            cards: [
                {
                    id: 'card_id_documents',
                    title: 'Identification Documents',
                    type: 'files',
                    fields: ['FILE_GOV_ID', 'FILE_DRIVERS_LICENSE'],
                    position: {
                        row: 0, col: 0, sizeX: 3, sizeY: 3
                    }
                },
                {
                    id: 'card_certifications',
                    title: 'Certifications',
                    type: 'files',
                    fields: ['FILE_CPR_CERT', 'FILE_FOOD_HANDLER'],
                    position: {
                        row: 0, col: 3, sizeX: 3, sizeY: 3
                    }
                }
            ]
        },
        {
            id: 'tab_history',
            label: 'History',
            icon: 'history',
            cards: [
                {
                    id: 'card_audit_log',
                    title: 'Profile Audit Log',
                    type: 'timeline',
                    fields: ['HIST_DATE', 'HIST_ACTION', 'HIST_USER'],
                    position: {
                        row: 0, col: 0, sizeX: 6, sizeY: 4
                    }
                }
            ]
        }
    ]
};
